export function get(url) {
  const separator = url.includes('?') ? '&' : '?';
  const cacheBustedUrl = `${url}${separator}_=${Date.now()}`;

  return fetch(cacheBustedUrl, { cache: 'no-store' }).then((response) => {
    if (response.ok) {
      return response.text();
    }

    return Promise.reject(response);
  });
}

export function post(url, data) {
  return new Promise((resolve, reject) => {
    /* eslint-disable */
    const request = new XMLHttpRequest();
    /* eslint-enable */
    request.open('POST', url, true);
    request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    /* eslint-disable */
    request.onload = function () {
      /* eslint-enable */
      if (request.status >= 200 && request.status < 400) {
        resolve(request.responseText);
      } else {
        reject(request);
      }
    };
    /* eslint-disable */
    request.onerror = function (err) {
      /* eslint-enable */
      reject(request, err.responseText);
    };
    request.send(JSON.stringify(data));
  });
}
